var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedStatic = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 3C1 2.44772 1.44772 2 2 2H14C14.5523 2 15 2.44772 15 3V4H1V3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 5H3V13H2C1.44772 13 1 12.5523 1 12V5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 6C4 5.44772 4.44772 5 5 5H14C14.5523 5 15 5.44772 15 6V8H4V6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 9H9V13H5C4.44772 13 4 12.5523 4 12V9Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M10 9H15V12C15 12.5523 14.5523 13 14 13H10V9Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedStatic);
export default ForwardRef;